import { createAsyncThunk } from '@reduxjs/toolkit';

import { IGroupedTopicsWithSubTopicsData, ISubTopic } from '.';
import { APIDataProvider, TApiResponse, ApiPaths } from '../../api';

const apiDataProvider = new APIDataProvider();

export const getSubTopicById = createAsyncThunk(
  'subtopic/id',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<ISubTopic>>(
      `${ApiPaths.subTopics}/${id}`
    );
    return response.data;
  }
);

export const getGroupedSubTopics = createAsyncThunk(
  'subTopic/groupedSubTopics',
  async (data: { subTopicId: string }) => {
    const response = await apiDataProvider.post<
      TApiResponse<IGroupedTopicsWithSubTopicsData>
    >(`${ApiPaths.subTopics}/groupedSubTopics`, data);

    return response.data;
  }
);
